<template>
  <div
    id="staffdev"
  >
    <Printer :title="agenda.AgendaName">
      <template v-slot:printContent>
        <div>
          <el-table
            class="table-striped"
            :lazy="isLazy"
            :header-cell-style="printHeaderCellStyle"
            header-row-class-name="text-danger"
            :cell-style="printCellStyle"
            :data="agenda.AgendaItems"
          >
            <el-table-column
              label="Start"
              prop="StartTime"
              :formatter="timeFormatter"
              width="130"
            />
            <el-table-column
              label="Title"
              prop="Topic"
              width="650"
            />
            <el-table-column
              label="Presented By"
              width="180"
            >
              <template slot-scope="props">
                {{ getStaffName(props.row.PresenterScouterKey) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </Printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'
import formatter from '@/services/formatter.js'

export default {
  name: 'PrintstaffDevelopment',
  components: {
    Printer
  },
  props: {
    agenda: {
      type: Object,
      default: function () {
        return {}
      }
    },
    staff: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      printCellStyle: { font: '18pt Raleway' },
      printHeaderCellStyle: { font: '18pt Raleway' },
      agendaName: null,
      location: null,
      startDate: null,
      isLazy: true
    }
  },
  watch: {
    agenda: function (newValue, oldValue) {
      if (newValue === null) {
        this.agendaName = null
        this.location = null
        this.startDate = null
      } else {
        this.agendaName = newValue.agendaName
        this.location = newValue.Location
        this.startDate = this.dateFormatter(newValue.StartDate)
      }
    }
  },
  methods: {
    timeFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsTime(cellValue)
    },
    dateFormatter: function (params) {
      return formatter.formatAsDate(params)
    },
    getStaffName: function (scouterKey) {
      const scouter = this.staff[scouterKey]

      if (scouter === undefined) {
        return ''
      } else {
        return scouter
      }
    }
  }
}
</script>
